import axios from "axios";
import React from "react";
import { Link, useLocation } from "react-router-dom";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: "English",
      languages: [],
      lang: "",
    };
  }
  componentDidMount() {
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const storedLangSlug = localStorage.getItem("siteLanguage") || "en";
    this.setState({ lang: storedLangSlug });

    // if (storedLangSlug === "ur") {
    //   document.body.classList.add("text-end");
    // } else {
    //   document.body.classList.remove("text-end");
    // }
    axios
      .post(`${BackendUrl}/language/multiple/1`)
      .then((response) => {
        const data = response.data.data;
        let selectedLanguage = data[0];
        if (storedLangSlug) {
          const foundLang = data.find((lang) => lang.slug === storedLangSlug);
          if (foundLang) {
            selectedLanguage = foundLang;
          }
        } else {
          localStorage.setItem("siteLanguage", selectedLanguage.slug);
        }
        this.setState({
          languages: data,
          selectedLanguage: selectedLanguage,
        });
      })
      .catch((error) => {
        console.error("Language fetch failed:", error);
      });
  }

  handleSelect = (langObj) => {
    this.setState({ selectedLanguage: langObj });
    localStorage.setItem("siteLanguage", langObj.slug);

    const { pathname } = this.props.location;
    // Check if current path matches "/our-course/:id"
    const ourCourseRegex = /^\/our-course\/[^/]+$/;
    if (ourCourseRegex.test(pathname)) {
      window.location.href = "/our-course";
    } else {
      window.location.reload();
    }
  };

  isActive(path) {
    const { pathname } = this.props.location;
    return pathname === path ? "active" : "";
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const navbar = document.getElementById("navbarCollapse");
      if (navbar && navbar.classList.contains("show")) {
        navbar.classList.remove("show");
      }
    }
  }
  render() {
    const {
      // phone, email,
      navLinks,
      brandName,
      // , brandHighlight
    } = this.props; //socialLinks
    const { selectedLanguage, languages } = this.state;

    return (
      <div
        className={`container-fluid sticky-top bg-white bg-body shadow ${
          this.state.lang === "ur" ? "direction-rtl" : ""
        }`}
      >
        {/* <div className="container topbar d-none d-lg-block">
          <div className="topbar-inner">
            <div className="row gx-0 justify-content-between">
              <div className="col-auto text-start">
                <div className="h-100 d-inline-flex align-items-center mx-2">
                  <span className="fa fa-phone-alt me-2 text-dark"></span>
                  <Link to="#" className="text-secondary">
                    <span>{phone[this.state.lang]}</span>
                  </Link>
                </div>
                <div className="h-100 d-inline-flex align-items-center">
                  <span className="far fa-envelope me-2 text-dark"></span>
                  <Link to="#" className="text-secondary">
                    <span>{email[this.state.lang]}</span>
                  </Link>
                </div>
              </div>
              <div className="col-auto text-end">
                <div className="h-100 d-inline-flex align-items-center">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle px-2 text-black-50"
                      data-bs-toggle="dropdown"
                    >
                      {selectedLanguage && (
                        <>
                          <span className="text-uppercase me-2">
                            {selectedLanguage.slug}
                          </span>
                          {selectedLanguage.name}
                        </>
                      )}
                    </Link>
                    <div className="dropdown-menu m-0 rounded-0">
                      {languages.map((lang) => (
                        <button
                          key={lang._id}
                          className="dropdown-item d-flex align-items-center"
                          onClick={() => this.handleSelect(lang)}
                        >
                          <span className="text-uppercase mx-1">
                            {lang.slug}
                          </span>
                          {lang.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="lqe_container">
          <nav className="navbar navbar-light navbar-expand-lg py-3">
            <Link to="/" className="lqe_logo me-2">
              <img src="./img/Lqe-Img/Lqe_logo.png" alt="" />
            </Link>
            <Link to="/" className="navbar-brand">
              <h5 className="mb-0 text-primary lqe_text">
                {brandName[this.state.lang]}
              </h5>
              <p className="mb-0 text-primary text-center lqe_slog mobile">
                The Ultimate Online Islamic <br/> Eduction Platform
              </p>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="fa fa-bars text-primary"></span>
            </button>
            <div
              className="collapse navbar-collapse bg-white"
              id="navbarCollapse"
            >
              <div className="navbar-nav ms-lg-auto mx-xl-auto">
                {navLinks.map((link, index) =>
                  link.dropdown ? (
                    <div className="nav-item dropdown" key={index}>
                      <Link
                        to="#"
                        className="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        {link.label[this.state.lang]}
                      </Link>
                      <div className="dropdown-menu m-0 rounded-0">
                        {link.dropdownItems.map((item, idx) => (
                          <Link
                            key={idx}
                            to={item.to}
                            className={`dropdown-item ${this.isActive(
                              item.to
                            )}`}
                          >
                            {item.label[this.state.lang]}
                          </Link>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <Link
                      key={index}
                      to={link.to}
                      className={`nav-item nav-link ${this.isActive(link.to)}`}
                    >
                      {link.label[this.state.lang]}
                    </Link>
                  )
                )}
                <Link to="/donate" className={`nav-item nav-link mobile`}>
                  {this.state.lang === "ur" ? <>عطیہ دیں</> : <>Donate Us</>}
                </Link>
                <div className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle px-2"
                    data-bs-toggle="dropdown"
                  >
                    {selectedLanguage && (
                      <>
                        {/* <span className="text-uppercase me-2">
                          {selectedLanguage.slug}
                        </span> */}
                        {selectedLanguage.name}
                      </>
                    )}
                  </Link>
                  <div className="dropdown-menu m-0 rounded-0 position-absolute">
                    {languages.map((lang) => (
                      <button
                        key={lang._id}
                        className="dropdown-item d-flex align-items-center"
                        onClick={() => this.handleSelect(lang)}
                      >
                        <span className="text-uppercase mx-1">{lang.slug}</span>
                        {lang.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <Link
                to="/donate"
                className="btn btn-primary py-2 px-4 d-none d-xl-inline-block"
              >
                {this.state.lang === "ur" ? <>عطیہ دیں</> : <>Donate</>}
              </Link>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

function WithLocationWrapper(props) {
  const location = useLocation();
  return <Header {...props} location={location} />;
}

export default WithLocationWrapper;
